<template>
<!-- 核销记录 -->
  <div class="app-container">
    <el-form :model="queryParams" ref="queryForm" :inline="true" v-show="showSearch" label-width="108px">
      <el-form-item label="会员名称:" prop="memberName">
        <el-input v-model="queryParams.memberName" placeholder="请输入会员名称" clearable size="small" @keyup.enter.native="handleQuery" />
      </el-form-item>
      <el-form-item label="核销人名称:" prop="verifyName">
        <el-input v-model="queryParams.verifyName" placeholder="请输入核销人名称" clearable size="small" @keyup.enter.native="handleQuery" />
      </el-form-item>
      <el-form-item label="卡券名称:" prop="cardName">
        <el-input v-model="queryParams.cardName" placeholder="请输入卡券名称" clearable size="small" @keyup.enter.native="handleQuery" />
      </el-form-item>
      <el-form-item v-if="enterpriseType===1" label="药店名称:" prop="storeName">
        <el-input v-model="queryParams.storeName" placeholder="请输入药店名称" clearable size="small" @keyup.enter.native="handleQuery" />
      </el-form-item>
      <el-form-item label="核销时间范围:" prop="date">
        <el-date-picker
          v-model="queryParams.date"
          type="datetimerange"
          align="right"
          unlink-panels
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="cyan" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table v-loading="loading" :data="dataList">
      <el-table-column label="会员名称" align="center" prop="memberName" />
      <el-table-column v-if="pageType===1" label="药企名称" align="center" prop="enterpriseName" />
      <el-table-column label="药店名称" align="center" prop="storeName" />
      <el-table-column label="核销人名称" align="center" prop="verifyName" />
      <el-table-column label="卡券名称" align="center" prop="cardName" />
      <el-table-column label="卡券面额" align="center" prop="cardDenom" />
      <el-table-column label="卡券编号" align="center" prop="cardNum" />
      <el-table-column label="创建时间" align="center" prop="createTime" />
      <!-- <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
        <template slot-scope="scope">
        </template>
      </el-table-column> -->
    </el-table>

    <!-- <pagination v-show="total>0" :total="total" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="getList" /> -->
    <el-pagination v-show="total>0"  :current-page.sync="queryParams.pageNum" :page-size="queryParams.pageSize" @size-change="getList" @current-change="getList" :page-sizes="[10, 20, 30, 40, 50]" background="" layout="sizes, prev, pager, next" :total="total"></el-pagination>
     <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose">
    </el-dialog>
  </div>
</template>

<script>
let self = null;
import { cardVerifyList } from "@/api/system/operation";
import {deepClone} from '@/utils/index'
export default {
  name: "cancelAfterVerification",
  data() {
    return {
      enterpriseType: localStorage.getItem('enterpriseType'),
      pageType: 0,
      title: '',
      type: null,
      selctLoading: false,
      // 遮罩层
      loading: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      doctorId: null,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 20,
        date: [],
        memberName: '',
        verifyName: '',
        cardName: '',
        storeName: ''

      },
      // 表单参数
      // 表单校验
      dataList: [],
      loading: false,
      dialogVisible: false,
      pickerOptions: this.getPickerOptions()
    };
  },
  created() {
    self = this;
    self.loading = false;
    self.getList();
  },
  mounted() {

  },
  methods: {
    /**
     * 返回时间快捷选项
     * @returns 返回时间快捷选项
     */
    getPickerOptions() {
      return {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        }
    },
    // 弹框关闭前钩子
    handleClose() {
      this.dialogVisible = false
    },
    closeDialog() {
      self.open = false;
      self.getList();
    },
    getList() {
      this.loading = true
      const data = deepClone(this.queryParams)
      const {date} = data
      if(Array.isArray(date) && date.length > 0) {
        data.startTime = date[0]
        data.endTime = date[1]
      }
      delete data.date
      const loginData = JSON.parse(localStorage.getItem('loginData'))
      const enterpriseType = localStorage.getItem('enterpriseType')
      data.enterpriseId = loginData.enterpriseId
      if(enterpriseType == 2) {
        data.storeId = loginData.storeId
      }
      cardVerifyList(data).then((res) => {
        if (res.code == 200) {
          self.dataList = res.data.records || [];
          self.total = res.data.total || 0;
        }
      }).finally(_=>{
        setTimeout(_=>{
          this.loading = false
        },500)
      })
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.areaList = [];
      this.doctorId = null;
      this.form = {
        id: null,
        enterpriseName: null,
        enterpriseCity: null,
        detailAddress: null,
        enterpriseAccount: null,
        enterprisePassword: null,
        accountStatus: "1",
        chargePerson: null,
        contactWay: null,
        businessLicense: null,
        saleLicense: null,
        expiryStartDate: null,
        expiryEndDate: null,
        enterpriseRemark: null,
        isDelete: null,
        createPerson: null,
        createTime: null,
        updatePerson: null,
        updateTime: null
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加医生";
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      this.open = true;
      this.title = "修改医生信息";
      this.doctorId = row.doctorId;
    },
    handleDetail(rows) {
      this.$router.push({ path: '/healthManage_detail', query: { doctorId: rows.doctorId } });
    },
    handleClickItem() {
      // 获取遮罩层dom
      setTimeout(() => {
        let domImageMask = document.querySelector(".el-image-viewer__mask");
        if (!domImageMask) {
          return;
        }
        domImageMask.addEventListener("click", () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector(".el-image-viewer__close").click();
        });
      })
    },
    // 用户状态修改
    handleStatusChange(row) {
      let text = row.doctorStatus === 2 ? "启用" : "停用";
      this.$confirm(`确认要${text}${row.doctorName}用户吗？`, "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return changeUserStatus(row.doctorId, row.doctorStatus);
      }).then(() => {
        this.msgSuccess(text + "成功");
      }).catch(function () {
        row.doctorStatus = row.doctorStatus === 2 ? 1 : 2;
      });
    },
  }
};
</script>
<style lang="less" scoped>
.demo-ruleForm {
  // width: 350px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.el-scrollbar__wrap {
  overflow-x: hidden !important;
}
.el-scrollbar__wrap .el-form {
  // margin-right: 15px !important;
}
.health_tag {
  margin: 30px;
  /deep/ .el-tag {
    margin-right: 20px;
    margin-bottom: 20px;
  }
}
</style>
